import { type AxiosError } from 'axios'
import { type IntlShape } from 'react-intl'

import { type BackendApiResponseError } from '../base-errors'

import {
  ERR_DOB_INVALID,
  ERR_DOB_TOO_YOUNG,
  ERR_EMAIL_INUSE,
  ERR_EMAIL_INVALID,
  ERR_EMAIL_MISSING_INVALID_FORMAT,
  ERR_FIRSTNAME_INVALID,
  ERR_LASTNAME_INVALID,
  ERR_PASSWORD_LENGTH_EXCEEDED,
  ERR_PASSWORD_TOOSHORT,
  ERR_SALUTATION_ERROR,
  ERR_TOS_NOT_ACCEPTED,
  MIN_AGE,
} from './consts'
import { MAX_PASSWORD_LENGTH } from './registrationFormValidation'

export const getRegistrationApiInvalidParamsErrorKeys = (
  error: AxiosError<BackendApiResponseError>,
): string[] => {
  if (error.response?.data.invalidParams) {
    return error.response.data.invalidParams.map(
      (invalidParam) => invalidParam.key,
    )
  }

  return []
}

export const getTranslationErrorMessagesForRegistration = (
  intl: IntlShape,
): Map<string, string> => {
  const map = new Map<string, string>()
  map.set(ERR_DOB_INVALID, intl.formatMessage({ id: ERR_DOB_INVALID }))
  map.set(
    ERR_DOB_TOO_YOUNG,
    intl.formatMessage(
      { id: 'login.createAccount.dateSelection.minAge' },
      { minAge: MIN_AGE },
    ),
  )
  map.set(
    ERR_EMAIL_INUSE,
    intl.formatMessage({ id: 'register.error.email.inUse' }),
  )
  map.set(
    ERR_EMAIL_INVALID,
    intl.formatMessage({ id: 'register.error.email.invalid' }),
  )
  map.set(
    ERR_EMAIL_MISSING_INVALID_FORMAT,
    intl.formatMessage({ id: 'register.error.email.invalid' }),
  )
  map.set(
    ERR_FIRSTNAME_INVALID,
    intl.formatMessage({ id: 'error.firstName.invalid' }),
  )
  map.set(
    ERR_LASTNAME_INVALID,
    intl.formatMessage({ id: 'error.lastName.invalid' }),
  )
  map.set(
    ERR_PASSWORD_TOOSHORT,
    intl.formatMessage({ id: 'error.password.tooShort' }),
  )
  map.set(
    ERR_PASSWORD_LENGTH_EXCEEDED,
    intl.formatMessage(
      { id: 'form.error.input.maxLength' },
      { maxLength: MAX_PASSWORD_LENGTH },
    ),
  )
  map.set(
    ERR_TOS_NOT_ACCEPTED,
    intl.formatMessage({ id: 'error.tos.notAccepted' }),
  )
  map.set(
    ERR_SALUTATION_ERROR,
    intl.formatMessage({ id: 'error.salutation.notChosen' }),
  )

  return map
}
